module.exports = __webpack_public_path__ + "img/map_yun_right.662be3f8.png";